"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNodeChildrenFromStep = exports.shouldAddArtificialEndingNode = exports.convertListOfStepsToNodeMap = void 0;
/* this generic function converts:
  - process content field
  - OR procedure steps field
  to a node-map
*/
function convertListOfStepsToNodeMap(content) {
    var _a = createMapFromSteps(content), map = _a[0], orderedIds = _a[1];
    for (var _i = 0, orderedIds_1 = orderedIds; _i < orderedIds_1.length; _i++) {
        var id = orderedIds_1[_i];
        var node = map[id];
        node.children = getNodeChildrenFromStep(id, node, orderedIds);
    }
    if (shouldAddArtificialEndingNode(map, orderedIds)) {
        var lastNode = map[orderedIds[orderedIds.length - 1]];
        lastNode.children = ["artificial-ending"];
        map["artificial-ending"] = {
            type: "ending",
            children: [],
            body: null,
        };
    }
    // return orderedIds without the start node
    return [map, orderedIds.slice(1)];
}
exports.convertListOfStepsToNodeMap = convertListOfStepsToNodeMap;
/* creates initial NodeMapType from an array of procedure/process steps.
  all node elements in the created map has empty children arrays.
  They still need to be populated.
 */
function createMapFromSteps(content) {
    var orderedIds = ["start"];
    // https://basarat.gitbook.io/typescript/type-system/index-signatures#excluding-certain-properties-from-the-index-signature
    // @ts-ignore - sadly there's no way to mix known keys & index signature
    var map = {
        start: { type: "start", children: [], body: null },
    };
    content.reduce(function (map, step, index) {
        var id = step.id || (step.n || index).toString();
        orderedIds.push(id);
        // @ts-ignore typescript doesn't know but we are respecting the types here
        map[id] = {
            children: [],
            type: step.type || "content",
            body: step,
        };
        return map;
    }, map);
    return [map, orderedIds];
}
function shouldAddArtificialEndingNode(map, orderedIds) {
    var lastNodeId = orderedIds[orderedIds.length - 1];
    var lastNode = map[lastNodeId];
    return lastNode.type !== "ending" && lastNode.children.length === 0;
}
exports.shouldAddArtificialEndingNode = shouldAddArtificialEndingNode;
function getNodeChildrenFromStep(nodeId, node, orderedIds) {
    var _a;
    switch (node.type) {
        case "decision": {
            var validChoices = extractDecisionStepValidChoices((_a = node.body) === null || _a === void 0 ? void 0 : _a.choices, orderedIds);
            if (validChoices.length > 0) {
                return validChoices;
            }
        }
        case "start":
        case "processprocedure":
        case "content": {
            var next = getNextNodeIdfromStep(nodeId, node, orderedIds);
            return next != null ? [next] : [];
        }
        case "ending":
        default:
            return [];
    }
}
exports.getNodeChildrenFromStep = getNodeChildrenFromStep;
function getNextNodeIdfromStep(nodeId, node, orderedIds) {
    var _a;
    var nextVal = node.type == "content" || node.type == "processprocedure" ? (_a = node.body) === null || _a === void 0 ? void 0 : _a.next : null;
    return nextVal != null && orderedIds.indexOf(nextVal) > -1
        ? nextVal
        : orderedIds[orderedIds.indexOf(nodeId) + 1];
}
function extractDecisionStepValidChoices(choices, orderedIds) {
    return (choices || [])
        .filter(function (c) { return c.dest != null && orderedIds.indexOf(c.dest) > -1; })
        .map(function (c) { return c.dest; });
}
